/* eslint-disable import/no-anonymous-default-export */
import { DASHBOARD } from "routes/route.constant";
import Dashboard from "pages/Dashboard";

export default {
  path: DASHBOARD,
  element: Dashboard,
};
